<div>
  <p>{{ queries.application_name }}へログイン連携しますか？</p>
</div>
<div style="display: flex">
  <div>
    <button (click)="confirm()">はい</button>
  </div>
  <div>
    <button (click)="cancel()">キャンセル</button>
  </div>
</div>
